import type qs from 'qs';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

import type { Lens } from './lens';
import { parseQueryStringLens } from './parse-query-string-lens';

export function useUrlQueryValue<A>(options: {
	lens: Lens<qs.ParsedQs, unknown, A, never>;
}): A;

export function useUrlQueryValue(options?: { lens?: never }): qs.ParsedQs;

export function useUrlQueryValue<A>(options?: {
	lens?: Lens<qs.ParsedQs, unknown, A, never>;
}): qs.ParsedQs | A;

export function useUrlQueryValue<A>({
	lens,
}: {
	lens?: Lens<qs.ParsedQs, unknown, A, never>;
} = {}) {
	const location = useLocation();

	const result = useMemo(() => {
		const l = parseQueryStringLens.then(lens);
		return l.get(location.search);
	}, [lens, location.search]);

	return result;
}
